module.exports = __webpack_public_path__ + "static/logo-93326a916609381db6a9b85ae83f3f7f.png";